var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('loading'),_c('header-area'),(!_vm.isInDashBoard)?_c('keep-alive',{attrs:{"include":/List\b/,"max":1}},[_c('router-view')],1):_c('router-view'),_c('footer-area')],1)}
var staticRenderFns = []

export { render, staticRenderFns }